import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from "vue-axios";

import products from './modules/products'

import actions from './actions'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex);
Vue.use(VueAxios, axios);

//BaseUrl from .env[.mode] file
//Vue.axios.defaults.baseURL = process.env.VUE_APP_API_BASE;
let session = null;
/*if (process.env.NODE_ENV === 'development') {  
  session = {
    "jwt": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJpYXQiOjE1ODYwNjkwMDEsImp0aSI6IktqdjhJQm1uVldKVmZPY2l0ZDh4cHh6Y09WU2JlRVdvMzRWMFMrVFwvVHg4PSIsImlzcyI6Imh0dHA6XC9cL2FudG9uaW9udWV2YS5rbngtZ3JvdXAtbmV0XC8iLCJuYmYiOjE1ODYwNjkwMDEsImV4cCI6MTY1ODA2OTAwMSwiZGF0YSI6eyJpZCI6Mjg0OCwibmFtZSI6ImFudG9uaW9AZnV0dXJhc211cy1rbnhsYWIuZXMiLCJpZGJhc2VnZXN0Y2xpZW50ZXMiOm51bGwsImdydXBvcGFpcyI6IjM0IiwicGFpc193ZWIiOiJFUyIsImlkX3BhaXNfd2ViIjoiMzQiLCJpZGlvbWFfZ2VuZXJpY28iOiJFTiIsImdkZXNwZWNpYWwiOiJHZW5lcmFsIiwiaWRRdWFydHVwQ2xpZW50ZVNpblNlcmllIjoiNDMwMDAwMTc4In19.BqHrhCTIMDbAzxhZU2mm9l2Um9cv3-YnA5Nzid3UnkO1RJLALmkko-udoCNQSCtOjSDuirR52FsbXDULdyaF3w",
    "user": {
      "id":-1,
      "name":"vue-development",
      "surname":"vue-development",
      "email":"vue-development",
      "username":"", 
      "password?":"", 
    }
  };

  localStorage.setItem('currentUser', JSON.stringify(session));
}*/

session= localStorage.getItem('currentUser');
if (session) {
  session = JSON.parse(session);
  Vue.axios.defaults.headers.common = {'Authorization': session.jwt} //copy this token from futurasmus page in localStorage
}  

export default new Vuex.Store({
   // Making sure that we're doing
  // everything correctly by enabling
  // strict mode in the dev environment.
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    loading: 0 ,
    translations: []  
  },
  mutations,
  actions,
  getters,
  modules: {
    products: products
  }
})
